// Mirrors sc-backend-api Transport::Rates::Calculator#dimensional_lbs so ops see
// the same dimensional weight that core uses.
export const DIM_FACTOR = 166;
const CM_TO_IN = 0.393701;

// Returns the dimensional weight in lb, or null when a dimension is missing.
export const dimensionalWeightLbs = (sizeOptions) => {
  if (!sizeOptions) return null;

  const { length, width, height, unit } = sizeOptions;
  const dims = [length, width, height];
  if (dims.some((d) => d === null || d === undefined || d === "")) return null;

  const factor = String(unit || "").toLowerCase() === "cm" ? CM_TO_IN : 1;
  return dims.reduce((product, d) => product * Number(d) * factor, 1) / DIM_FACTOR;
};

export const formatDimensionalWeight = (sizeOptions) => {
  const lbs = dimensionalWeightLbs(sizeOptions);
  return lbs === null || Number.isNaN(lbs) ? "-" : `${lbs.toFixed(2)} lb`;
};
